'use strict';

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var BlankState = function BlankState(props) {
    return _react2['default'].createElement('div', _extends({ className: 'BlankState' }, props));
};
var BlankStateHeading = function BlankStateHeading(props) {
    return _react2['default'].createElement('h2', _extends({ className: 'BlankState__heading' }, props));
};

module.exports = {
    BlankState: BlankState,
    BlankStateHeading: BlankStateHeading
};


//////////////////
// WEBPACK FOOTER
// /smarthelpnodeweb-ci-5863/workspace/Release_Build/~/kepler/lib/components/BlankState.js
// module id = 954
// module chunks = 0 1